import { ReactComponent as Warning } from '../../../../../../icons/infoCircle.svg'
import React, { useEffect, useMemo, useState } from 'react'

import { SelectV2 } from '../../../../../../uikit/SelectV2/SelectV2'
import { useLocation, useNavigate } from 'react-router-dom'
import { Bubbles } from './components/Bubbles/Bubbles'
import { PAYMENTS_MERCHANTS } from './constants'
import styles from './PayMethodsV2.module.scss'
import { Card } from './components/Card/Card'
import { useSelector } from 'react-redux'

export const PayMethodsV2 = ({
  payment_method_id,
  setPayment_method_id,
  payMethodId,
  setNoIframe,
  setCurrency,
  duration,
  setDuration,
  setDurationErr,
  setPmidForPaytabs,
  selectedMethod,
  setSelectedMethod
}) => {
  const [filteredPms, setFilteredPms] = useState([])
  const [selectedBubble, setSelectedBubble] = useState(1)
  const [initialMethod, setInitialMethod] = useState(null)

  const result = useSelector((state) => state.result)

  const payMethodsList = result?.frame_companies?.find((el) => el)?.company_info
    .payment_methods

  const location = useLocation()
  const url = window.location.href
  const urlOrgin = new URL(url).origin
  const gate = new URLSearchParams(location.search).get('gate')
  const curid = new URLSearchParams(location.search).get('curid')

  const navigate = useNavigate()

  useEffect(() => {
    if (urlOrgin.endsWith('.ae')) {
      if (payMethodsList?.length) {
        const findPaytabs = payMethodsList?.find(
          (item) => item.merchant_type === 'paytabs'
        )
        setSelectedMethod(findPaytabs)
      }
    }
  }, [payMethodsList])

  useEffect(() => {
    if (!payMethodsList?.length) {
      return
    }

    if (payMethodId) {
      setPayment_method_id(Number(payMethodId))
      setFilteredPms(payMethodsList?.filter((item) => item.id === +payMethodId))
    } else {
      const primaryMethod =
        selectedMethod ||
        (curid
          ? payMethodsList?.find((item) => item.id === +curid)
          : payMethodsList?.find((item) => !item.is_secondary))

      setInitialMethod(primaryMethod)

      if (primaryMethod) {
        setPayment_method_id(primaryMethod.id)
        setFilteredPms(
          payMethodsList?.filter(
            (item) => item.is_secondary === primaryMethod.is_secondary
          )
        )
        setSelectedBubble(primaryMethod.is_secondary ? 2 : 1)
        setCurrency(primaryMethod.currency)

        const howOpen = PAYMENTS_MERCHANTS.find(
          (item) => item.type === primaryMethod.merchant_type
        ).iframe
        setNoIframe(howOpen)
        if (primaryMethod.merchant_type === 'paytabs') {
          setPmidForPaytabs(primaryMethod.id)
        }
      }
    }
  }, [payMethodsList, payMethodId, selectedMethod, curid])

  useEffect(() => {
    if (!urlOrgin.includes('localhost')) {
      if (initialMethod?.merchant_type === 'paytabs') {
        if (!urlOrgin.endsWith('.ae')) {
          const newUrl = url.replace(/\.ru(?=\/|$)/, '.ae')
          window.location.href = newUrl
        }
      }
    }
  }, [urlOrgin, url, initialMethod])

  const handleChangeBubbles = (value) => {
    if (value === 1) {
      const filtered = payMethodsList?.filter((item) => !item.is_secondary)
      setFilteredPms(filtered)
      setSelectedMethod(filtered?.[0])
      setPayment_method_id(filtered?.[0]?.id)
      const isPaytabs = filtered?.[0]?.merchant_type === 'paytabs'
      setPmidForPaytabs(isPaytabs ? filtered?.[0]?.id : null)

      if (!urlOrgin.includes('localhost')) {
        if (!isPaytabs) {
          if (!urlOrgin.endsWith('.ru')) {
            const newUrl = url.replace(/\.ae(?=\/|$)/, '.ru')
            window.location.href = newUrl
          } else {
            const searchParams = new URLSearchParams(location.search)
            searchParams.delete('curid')
            navigate({
              search: searchParams.toString()
            })
          }
        }
      }
    } else if (value === 2) {
      const filtered = payMethodsList?.filter((item) => item.is_secondary)
      setFilteredPms(filtered)
      setSelectedMethod(filtered?.[0])
      setPayment_method_id(filtered?.[0]?.id)
    }
  }

  const handleSelectPm = (cardItem) => {
    setPayment_method_id(cardItem?.id)
    setDuration('')
    if (cardItem?.merchant_type === 'paytabs') {
      setPmidForPaytabs(cardItem?.id)
      setSelectedMethod(cardItem)
      const searchParams = new URLSearchParams(location.search)
      searchParams.delete('curid')
      navigate({
        search: searchParams.toString()
      })
    } else {
      setPmidForPaytabs(null)
      setSelectedMethod(cardItem)
      if (!urlOrgin.includes('localhost')) {
        if (!urlOrgin.endsWith('.ru')) {
          const newUrl = url.replace(/\.ae(?=\/|$)/, '.ru')
          window.location.href = `${newUrl}?curid=${cardItem?.id}`
        } else if (url.includes('curid')) {
          navigate({
            search: `curid=${cardItem?.id}`
          })
        }
      }
    }
  }

  const btnsOptions = useMemo(() => {
    const PRIMARY_OPTION = { value: 1, label: 'Основные' }
    const SECONDARY_OPTION = {
      value: 2,
      label: 'Дополнительные'
    }

    const options = [PRIMARY_OPTION]

    if (payMethodsList?.some((item) => item.is_secondary)) {
      options.push(SECONDARY_OPTION)
    }

    return options
  }, [payMethodsList])

  const durationData = useMemo(() => {
    if (payMethodsList?.length && payment_method_id) {
      const item = payMethodsList?.find((el) => el.id === payment_method_id)
      if (item?.duration.length) {
        setDurationErr(true)
        return item?.duration
      }
    }
    setDurationErr(false)
    return null
  }, [payMethodsList, payment_method_id])

  const bankText = useMemo(() => {
    let text = ''
    if (payMethodsList?.length && payment_method_id) {
      const item = payMethodsList?.find((el) => el.id === payment_method_id)
      if (item) {
        switch (item.type_payment) {
          case 'ru':
            text = 'российских банков'
            break
          case 'foreign':
            text = 'зарубежных банков'
            break
          case 'all':
            text = 'российских и зарубежных банков'
            break
          default:
            text = 'российских банков'
        }
      }
    }
    return text
  }, [payMethodsList, payment_method_id])

  return (
    <div className={styles.root} data-testid="pay-methods-root">
      <p className={styles.title} data-testid="pay-methods-title">
        Способ оплаты
      </p>

      {!payMethodId && (
        <Bubbles
          btnsOptions={btnsOptions}
          handleChange={handleChangeBubbles}
          selectedBubble={selectedBubble}
          setSelectedBubble={setSelectedBubble}
        />
      )}
      <div className={styles.cardsBox} data-testid="pay-methods-cardsBox">
        {filteredPms?.map((item, idx) => (
          <Card
            item={item}
            key={idx}
            payment_method_id={payment_method_id}
            handleSelectPm={handleSelectPm}
          />
        ))}
      </div>

      {durationData && (
        <div data-testid="instalment-select-box" className={styles.selectBox}>
          <label data-testid="select-label" id="select-label" htmlFor="select">
            Количество месяцев для погашения: <span>*</span>
          </label>
          <SelectV2
            value={duration}
            id="select"
            onChange={(e) => {
              setDuration(e.target.value)
              setDurationErr(false)
            }}
            placeholder="Выберите период"
            options={[
              { value: '', label: 'Выберите период' },
              ...durationData?.map((item) => ({
                value: item,
                label: `${item} месяцев`
              }))
            ]}
            data-testid="instalment-select"
          />
        </div>
      )}
      {bankText && (
        <div data-testid="payMtds-desc" className={styles.payMtdsDesc}>
          <Warning />
          <div data-testid="payMtds-text" className={styles.payMtdsText}>
            <span>Этот платёжный метод поддерживает оплату картами</span>{' '}
            <span className={styles.textBold}>{bankText}</span>
          </div>
        </div>
      )}
    </div>
  )
}
